import Flex from '@components/Flex/Flex';
import { styled } from '@mui/material';

export const StyledContainer = styled(Flex)(({ theme }) => ({
  width: 287,
  minWidth: 287,
  height: 240,
  border: `1px solid ${theme.palette.black[200]}`,
  borderRadius: theme.spacing(4),
  flexDirection: 'column',
  overflow: 'hidden',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    minWidth: '100%',
  },
}));

export const ThumbnailContainer = styled(Flex)(({ theme }) => ({
  paddingLeft: theme.spacing(16),
  paddingRight: theme.spacing(16),
  paddingTop: theme.spacing(12),
  height: 184,
  backgroundColor: theme.palette.grey[100],
  flex: '1 0 auto',
}));

export const Thumbnail = styled('img')(({ theme }) => ({
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  objectPosition: 'top',
  borderStartStartRadius: theme.spacing(8),
  borderStartEndRadius: theme.spacing(8),
  border: `1px solid ${theme.palette.grey[500]}`,
  borderBottom: 0,
}));

export const BottomContainer = styled(Flex)(({ theme }) => ({
  padding: theme.spacing(8),
  backgroundColor: theme.palette.common.white,
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: theme.spacing(12),
}));
